export default "__VITE_ASSET__bpML1VfZ__"